import {alphabeticalSort} from '@/helpers/index.js'

export const job = {
    state: {
        companies: [],
        locations: [],
        offers: [],
        types: []
    },
    mutations: {
        setLocations(state, locations) {
            state.locations = alphabeticalSort(locations, 'name')
        },
        setOffers(state, offers) {
            state.offers = offers
        },
        setTypes(state, types) {
            state.types =  alphabeticalSort(types, 'name')
        },
        setCompanies(state, types) {
            state.companies =  alphabeticalSort(types, 'name')
        }
    },
    actions: {
        setLocations(context, locations) {
            context.commit('setLocations', locations)
        },
        setOffers(context, offers) {
            context.commit('setOffers', offers)
        },
        setTypes(context, types) {
            context.commit('setTypes', types)
        },
        setCompanies(context, types) {
            context.commit('setCompanies', types)
        }
    }
}